// Global ref for the navbar's SymbolSpotlight instance.
// Same pattern as Modals/ActiveIndicatorsModalRef — lets the chart context
// menu open the spotlight without prop drilling. Attached by SymbolDropdown.
export const symbolSpotlightRef = { current: null };
